var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArhiveFillDuotone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 62C26.667 61.0572 26.667 60.5858 26.9599 60.2929C27.2528 60 27.7242 60 28.667 60H131.334C132.276 60 132.748 60 133.041 60.2929C133.334 60.5858 133.334 61.0572 133.334 62V100C133.334 112.571 133.334 118.856 129.428 122.761C125.523 126.667 119.238 126.667 106.667 126.667H53.3336C40.7629 126.667 34.4775 126.667 30.5722 122.761C26.667 118.856 26.667 112.571 26.667 100V62Z",
    fill: "#FF0050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 46.6663C13.333 39.3025 19.3025 33.333 26.6663 33.333H133.333C140.697 33.333 146.666 39.3025 146.666 46.6663V46.6663C146.666 50.3482 143.682 53.333 140 53.333H19.9997C16.3178 53.333 13.333 50.3482 13.333 46.6663V46.6663Z",
    fill: "#FF0050"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 80,
    width: 40,
    height: 6.66667,
    rx: 3.33333,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArhiveFillDuotone);
export default __webpack_public_path__ + "static/media/Arhive_fill_duotone.59811b6ce71434b90b1072be4a6cfb89.svg";
export { ForwardRef as ReactComponent };